import { createContext } from 'react';
import type { ToastContextValue } from '../types/toastContext';

export const ToastContext = createContext<ToastContextValue | null>(null);
